import { ServiceHandler } from '../../utils';
import type { ThreatActorProfile } from '../../components/ask-moo/types';

/**
 * Fetch the rich threat-actor profile by MITRE id.
 * 200 → ThreatActorProfile | 404 unknown mitreId | 403 unauthorized.
 */
export const getThreatActorProfile = ServiceHandler<
  unknown,
  ThreatActorProfile
>({
  url: '/api/risk/v1/threat-actors/:mitreId',
});
